import type { ReactNode } from "react";
import { Icon } from "./Icon";
import { Button } from "./Button";

interface ErrorBannerProps {
  title?: string;
  message?: ReactNode;
  onRetry?: () => void;
  className?: string;
}

export function ErrorBanner({
  title = "No se pudo cargar la información",
  message,
  onRetry,
  className = "",
}: ErrorBannerProps) {
  return (
    <div
      className={`flex items-start gap-3 rounded-lg border border-danger/30 bg-danger-soft/60 p-4 ${className}`}
      role="alert"
    >
      <Icon name="alertCirc" size={18} className="text-danger mt-0.5 shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="text-sm font-semibold text-text">{title}</div>
        {message && <div className="text-xs text-text-2 mt-1">{message}</div>}
      </div>
      {onRetry && (
        <Button variant="quiet" size="sm" icon="refresh" onClick={onRetry}>
          Reintentar
        </Button>
      )}
    </div>
  );
}
